import { useEffect } from "react";
import { useNodesInitialized, useReactFlow } from "reactflow";

export const FitViewOnNodesInitialized = () => {
  const nodesInitialized = useNodesInitialized();
  const { fitView } = useReactFlow();

  useEffect(() => {
    if (nodesInitialized) fitView({ duration: 500 });
  }, [fitView, nodesInitialized]);

  return null;
};
